import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input, Dropdown } from 'semantic-ui-react'

import moment from 'moment'

import constants from '../../constants';

class SectionsAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      code: '',
      showModal: false,
      levelType: '',
      gradeLevel: '',
      teacherId: ''
    };
  }

  handleChange = (e, { name, value }) => {
    if(name === 'name') {
      let code = value.replace(/\s/g, '')
      code = code + '-' + this.state.gradeLevel + '-' + moment().format('MMDDYYYY')
      this.setState({ [name]: value, code:  code.toUpperCase() })
    } else {
      this.setState({ [name]: value })
    }
  }

  handleSubmit = () => {
    const data = {
      name: this.state.name,
      code: this.state.code,
      teacherId: this.state.teacherId,
      levelType: this.state.levelType,
      gradeLevel: this.state.gradeLevel,
      // Save into the school year currently selected in the dropdown, not the
      // one flagged isCurrent — otherwise sections added while viewing a future
      // school year silently land in the current one and never show up.
      schoolYearId: this.props.schoolYearId
    };
    this.props.handleSubmit(data);
    this.setState({
      name: '',
      code: '',
      teacherId: '',
      levelType: '',
      gradeLevel: ''
    })
    this.closeModal();
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  render() {
    let optionsTeachers;
    if (this.props.teachers) {
      optionsTeachers = this.props.teachers.map((teacher,index) => {
        const teacherName = teacher.firstName && teacher.lastName ? 
          teacher.lastName + ', '+ teacher.firstName : 
          'Unknown Teacher';
        return (
            { key: teacher.teacherId, value: teacher.teacherId, text: teacherName }
        )
      })
    }

    const optionsLevelType = constants.levelType;
    const optionsGradeLevel = constants.gradeLevel;

    return (
      <Modal
        trigger={
          <Button icon floated='right' labelPosition='right' color='green' onClick={this.openModal}> <Icon name='add' />
          Add Section
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>Add Section</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths='equal'>
              <Form.Select
                fluid
                name='levelType'
                label='Level Type'
                placeholder='Level Type'
                options={optionsLevelType}
                onChange={this.handleChange}
                value={this.state.levelType}
              />
              <Form.Select
                fluid
                name='gradeLevel'
                label='Grade Level'
                placeholder='Grade Level'
                options={optionsGradeLevel}
                onChange={this.handleChange}
                value={this.state.gradeLevel}
              />
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.name} name='name' label='Name' placeholder='Name' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.code} name='code' label='Code' placeholder='Code' disabled  className='section-disabled'/>
            </Form.Group>
            Teacher
            <Dropdown
              search
              selection
              fluid
              name='teacherId'
              className='teacher-dropdown'
              options={optionsTeachers}
              onChange={this.handleChange}
              value={this.state.teacherId}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.handleSubmit()}>Submit</Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default SectionsAdd;
